// src/components/battle/BattleInfoSection.jsx
import BattleNameInput from "./BattleNameInput";
import BattleDateInput from "./BattleDateInput";

export default function BattleInfoSection({
  battleName,
  onBattleNameChange,
  battleDateTime,
  onBattleDateChange,
}) {
  return (
    <section className="mb-4">
      <BattleNameInput value={battleName} onChange={onBattleNameChange} />
      <BattleDateInput value={battleDateTime} onChange={onBattleDateChange} />
    </section>
  );
}
